import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'replace',
    standalone: false
})
export class ReplacePipe implements PipeTransform {
    transform(value: string, searchValue, replaceValue): any {
        return value.replace(searchValue, replaceValue);
    }
}
